<script>
  import { userProfileStore } from "../store.js";
  import { supabase } from "../auth.js";
  import { onMount } from "svelte";

  export let close;

  let userProfile = $userProfileStore;

  onMount(async () => {
    const { body } = await supabase
      .from("users")
      .select("*")
      .eq("id", supabase.auth.user().id);
    $userProfileStore = body[0];
  });

  async function updateUserProfile() {
    const { body } = await supabase
      .from("users")
      .update([
        {
          name: userProfile.name,
          slogan: userProfile.slogan,
          description: userProfile.description,
          avatar_url: userProfile.avatar_url,
          youtube_url: userProfile.youtube_url,
          instagram_url: userProfile.instagram_url,
          spotify_url: userProfile.spotify_url,
        },
      ])
      .match({ id: supabase.auth.user().id });
    $userProfileStore = body[0];
  }

  function handleSubmit() {
    updateUserProfile();
    close();
  }
</script>

<div class="leading-loose">
  <form
    on:submit|preventDefault={handleSubmit}
    class="max-w-xl p-10 shadow-xl bg-gray-50 md:m-4 rounded-3xl"
  >
    <p class="text-lg font-medium text-gray-800">Nutzer Informationen</p>
    <div class="my-4">
      <label class="block text-sm text-gray-800" for="name">Name</label>
      <input
        class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
        id="name"
        name="name"
        type="text"
        required=""
        placeholder="Dein Name"
        aria-label="Name"
        bind:value={userProfile.name}
      />
    </div>
    <div class="my-4">
      <label class="block text-sm text-gray-800" for="name">Slogan</label>
      <input
        class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
        id="slogan"
        name="slogan"
        type="text"
        required=""
        placeholder="Dein Slogan"
        aria-label="Slogan"
        bind:value={userProfile.slogan}
      />
    </div>
    <div class="my-4">
      <label class="block text-sm text-gray-800" for="beschreibung"
        >Beschreibung</label
      >
      <textarea
        class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
        id="beschreibung"
        name="beschreibung"
        required=""
        placeholder="Deine Beschreibung"
        aria-label="Beschreibung"
        bind:value={userProfile.description}
      />
    </div>
    <div class="my-4">
      <label class="block text-sm text-gray-800" for="avatar_url"
        >Avatar URL</label
      >
      <input
        class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
        id="avatar_url"
        name="avatar_url"
        required=""
        placeholder="https://tactical-view.vercel.app/img/fan-profile-image.jpg"
        aria-label="Avatar URL"
        bind:value={userProfile.avatar_url}
      />
    </div>
    <div class="my-4">
      <label class="block text-sm text-gray-800" for="youtube_url"
        >Youtube URL</label
      >
      <input
        class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
        id="youtube_url"
        name="youtube_url"
        required=""
        placeholder="https://youtube.com/pewdiepie"
        aria-label="Youtube URL"
        bind:value={userProfile.youtube_url}
      />
    </div>
    <div class="my-4">
      <label class="block text-sm text-gray-800" for="instagram_url"
        >Instagram URL</label
      >
      <input
        class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
        id="instagram_url"
        name="instagram_url"
        required=""
        placeholder="https://instagram.com/pewdiepie"
        aria-label="Instagram URL"
        bind:value={userProfile.instagram_url}
      />
    </div>
    <div class="my-4">
      <label class="block text-sm text-gray-800" for="spotify_url"
        >Spotify URL</label
      >
      <input
        class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
        id="spotify_url"
        name="spotify_url"
        required=""
        placeholder="https://spotify.com"
        aria-label="Spotify URL"
        bind:value={userProfile.spotify_url}
      />
    </div>
    <div class="mt-4">
      <button
        class="w-full py-3 mt-6 text-white rounded-md bg-gradient-to-r from-fcred to-white focus:outline-none hover:bg-gray-700 hover:shadow-none"
        type="submit">Speichere deine Informationen</button
      >
    </div>
  </form>
</div>
